var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("pageTitle"),
      _c("business-group", {
        ref: "businessGroup",
        attrs: {
          tableConfig: { ..._vm.tableConfig },
          formConfig: { ..._vm.formConfig },
        },
        scopedSlots: _vm._u([
          {
            key: "formSlot",
            fn: function (formSlot) {
              return [
                _c(
                  "a-form-item",
                  [
                    _c("a-input-search", {
                      directives: [
                        {
                          name: "decorator",
                          rawName: "v-decorator",
                          value: ["keyword"],
                          expression: "['keyword']",
                        },
                      ],
                      staticStyle: { width: "270px" },
                      attrs: {
                        placeholder: "操作人员/操作类型/操作内容/ip地址",
                      },
                      on: { search: _vm.OnSearch },
                    }),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }